// third-party
import { configureStore } from '@reduxjs/toolkit';
import {
    useDispatch as useAppDispatch,
    useSelector as useAppSelector
} from 'react-redux';

// project imports
import rootReducer from './reducer';
import {
    persistedState,
    saveState
} from './persistedStore';

// ==============================|| REDUX - MAIN STORE ||============================== //

const appReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        localStorage.clear();
        state = undefined;
    }

    return rootReducer(state, action);
};

const store = configureStore({
    reducer: appReducer,
    preloadedState: persistedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false })
});

store.subscribe(() => {
    saveState(store.getState())
})

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { store, dispatch, useSelector, useDispatch };
